import React from 'react';
import { Layout, Row, Col, Typography, Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import LoginForm from '../../components/LoginForm/LoginForm';
import Footer from '../../components/Footer';
import LogoEmpresa from '../../assets/img/a-iso-blanco-8.png';
import './Login.scss';

const { Header, Content } = Layout;
const { Title } = Typography;

const Login = () => {
  const { tenant, organization, tenantLogo } = useSelector(
    (store) => store.tenantData
  );

  return (
    <Layout className="login-page">
      <Header>
        <Row justify="space-between" align="middle" style={{ width: '100%' }}>
          <Col>
            <Link to="/">
              <Avatar
                alt="Isotipo"
                src={LogoEmpresa}
                style={{
                  width: '30px',
                  height: '30px',
                  objectFit: 'cover',
                  borderRadius: '50%',
                  marginRight: 10,
                }}
              />
              <span style={{ color: 'white' }}>{organization}</span>
            </Link>
          </Col>
        </Row>
      </Header>

      <Content>
        <Row
          justify="center"
          align="middle"
          style={{ minHeight: 'calc(100vh - 64px - 70px)' }}
        >
          <Col xs={22} sm={16} md={12} lg={8}>
            <div className="login-container">
              <div className="login-header">
                <Avatar
                  src={`https://storage.googleapis.com/bs-proyecto1.appspot.com/${tenant}/${
                    tenantLogo || 'logo'
                  }.png`}
                  size={100}
                />
                <Title level={2}>{organization}</Title>
                <Title level={4}>Acceso a Mis Estudios</Title>
              </div>

              <LoginForm />
            </div>
          </Col>
        </Row>
      </Content>

      <Footer />
    </Layout>
  );
};

export default Login;
